<template>
  <div class="instagram-hashtag-input" @click="focusInput">
    <span
      v-for="(tag, index) in tags"
      :key="`${tag}-${index}`"
      class="instagram-hashtag-input__pill"
    >
      #{{ tag }}
      <button
        type="button"
        :aria-label="$t('ct-instagram-remove-hashtag')"
        class="instagram-hashtag-input__remove"
        @click.stop="removeTag(index)"
      >
        ×
      </button>
    </span>
    <input
      ref="input"
      v-model="draft"
      class="instagram-hashtag-input__field"
      type="text"
      :placeholder="placeholderText"
      @keydown.enter.prevent="addTag"
      @keydown.backspace="removeLastTag"
      @blur="addTag"
    />
  </div>
</template>

<script>
export default {
  name: 'InstagramHashtagTagInput',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      draft: '',
    };
  },
  computed: {
    tags() {
      return Array.isArray(this.value) ? this.value : [];
    },
    placeholderText() {
      return this.placeholder || this.$t('ct-instagram-hashtag-placeholder');
    },
  },
  methods: {
    focusInput() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    normalizeTag(raw) {
      return String(raw || '')
        .trim()
        .replace(/^#+/, '')
        .toLowerCase();
    },
    addTag() {
      const tag = this.normalizeTag(this.draft);
      this.draft = '';
      if (!tag) {
        return;
      }
      if (this.tags.indexOf(tag) !== -1) {
        return;
      }
      this.$emit('input', this.tags.concat([tag]));
    },
    removeTag(index) {
      const next = this.tags.slice();
      next.splice(index, 1);
      this.$emit('input', next);
    },
    removeLastTag(event) {
      if (this.draft !== '' || !this.tags.length) {
        return;
      }
      event.preventDefault();
      this.$emit('input', this.tags.slice(0, -1));
    },
  },
};
</script>

<style scoped>
.instagram-hashtag-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 38px;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  cursor: text;
}
.instagram-hashtag-input__pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e8f0fe;
  color: #1e293b;
  font-size: 12px;
  font-weight: 600;
}
.instagram-hashtag-input__remove {
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}
.instagram-hashtag-input__field {
  flex: 1 1 120px;
  min-width: 120px;
  border: 0;
  outline: none;
  font-size: 13px;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/InstagramFeed/HashtagTagInput.vue